import angular from 'angular'
import template from './template.html'

function NominasCfdiListaGrupoComponent() {
  let $ctrl = this;
  $ctrl.$onChanges = $onChanges;
  $ctrl.seleccionar = seleccionar;
  $ctrl.seleccionarTodo = seleccionarTodo;

  $ctrl.todosSeleccionados = false;

  function $onChanges(changes) {
    if (changes.seleccionados) {
      $ctrl.todosSeleccionados = $ctrl.nominas
        .every(function (item) {
          return item.seleccionado;
        });
    }
  }

  function notificar(items) {
    $ctrl.onSelect({$event: {data: items}})
  }

  function seleccionar(item) {
    notificar([item]);
  }

  function seleccionarTodo() {
    let seleccion = $ctrl.todosSeleccionados ?
      $ctrl.nominas : $ctrl.nominas
        .filter(function (item) {
          return !item.seleccionado;
        });

    notificar(seleccion);
  }
}

angular.module('nominas.cfdi')
  .component('nominasCfdiListaGrupo', {
    template: template,
    controller: NominasCfdiListaGrupoComponent,
    bindings: {
      proyecto: '<',
      nominas: '<',
      seleccionados: '<',
      onSelect: '&',
    },
  });



// WEBPACK FOOTER //
// ./src/nominas/cfdi/components/lista/grupo/controller.js